import './App.css';
import {Navigate, Route, Routes} from 'react-router-dom';
import PaymentsPage from './pages/PaymentsPage';
import NotFoundPage from "./pages/NotFoundPage";
import AuthSuccessPage from "./pages/AuthSuccessPage";
import SettingsPage from "./pages/SettingsPage";
import LoginPage from "./pages/LoginPage";
import { useAuth } from "./context/authContext";
import PaymentAuthPage from "./pages/PaymentAuthPage";
import UsersPage from "./pages/UsersPage";
import WorkflowsPage from "./pages/WorkflowsPage";
import WorkflowEditorPage from "./pages/WorkflowEditorPage";
import OrgSettingsPage from "./pages/OrgSettingsPage";
import Layout from "./components/layout/Layout";
import { useFeatureAccess } from "./hooks/useFeatureAccess";
import { isAllOrganisationsSelected } from "./utils/organisation";

function App() {

    const { authenticated, user } = useAuth();
    const { advancedFeaturesEnabled } = useFeatureAccess();
    // Organisation-scoped admin pages are hidden while viewing all organisations.
    const showAdminPages = user.role === 'Admin' && !isAllOrganisationsSelected(user);

    const standardRoutes = [
        {
            path: '/',
            element: <Navigate to='/payments' />
        },
        {
            path: '/payments',
            element: <PaymentsPage />
        },
        {
            path: '/payments/:paymentId',
            element: <PaymentAuthPage />
        },
        {
            path: '/settings',
            element: <SettingsPage />
        },
        {
            path: '/success',
            element: <AuthSuccessPage />
        },
        {
            path: '*',
            element: <NotFoundPage />
        }
    ];

    const adminRoutes = [
        {
            path: '/users',
            element: <UsersPage />
        },
        ...(advancedFeaturesEnabled ? [
            {
                path: '/workflows',
                element: <WorkflowsPage />
            },
            {
                path: '/workflows/:workflowId',
                element: <WorkflowEditorPage />
            },
            {
                path: '/org-settings',
                element: <OrgSettingsPage />
            },
        ] : []),
    ];

    if (!authenticated) {
        return (
            <LoginPage />
        );
    }

    return (
        <Routes>
            {/* Standard Routes */}
            {standardRoutes.map((route, index) => (
                <Route 
                    key={index} 
                    path={route.path}
                    element={
                        <Layout>
                            {route.element}
                        </Layout>
                    }
                />
            ))}

            {/* Admin Routes */}
            {showAdminPages && adminRoutes.map((route, index) => (
                <Route 
                    key={index} 
                    path={route.path}
                    element={
                        <Layout>
                            {route.element}
                        </Layout>
                    }
                />
            ))}
        </Routes>
    );
}

export default App;
